import { ICoworking } from 'shared/types/coworking';
import { TReduxActions } from 'shared/types/redux';

export function coworkingReducer(state: ICoworking, action: TReduxActions) {
  switch (action.type) {
    default:
      return state || null;
  }
}
